













































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { IRules } from '@/components/UI/Form/ValidationModule';
import { validateRequired } from '@/components/UI/Form/Validations';
import DeepCopy from '@/decorators/deep-copy';
import { GQL_ProductGroupCreate, GQL_ProductGroupUpdate } from '@/queries/global';
import { SmartQuery } from 'vue-apollo-decorator';
import { ALL_PRODUCT_GROUPS } from '@/queries/ProductGroup';
import { GQL_currentUnitProductGroups, GQL_currentUnitProductGroups_currentUnit_productGroups } from '@/queries/__generated__/currentUnitProductGroups';
import { isGroupAnAncestor, sortProductGroups } from '@/app/ProductGroup';

@Component
export default class ProductGroupForm extends Vue {
  @Prop({ required: true, type: Object }) private data!: GQL_ProductGroupCreate | GQL_ProductGroupUpdate;
  @DeepCopy('data') private formData!: GQL_ProductGroupCreate | GQL_ProductGroupUpdate;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) private query!: any;
  @Prop({ required: true, type: Function }) private formatDataForMutation!: Function;

  private validForm = true;

  @SmartQuery<ProductGroupForm, GQL_currentUnitProductGroups>({
    query: ALL_PRODUCT_GROUPS,
    update(data) {
      const groupMap: Map<string, GQL_currentUnitProductGroups_currentUnit_productGroups> = new Map();
      data.currentUnit.productGroups.forEach(g => groupMap.set(g.id, g));

      return sortProductGroups(
        data.currentUnit.productGroups
          .filter(g => !('id' in this.formData) || !isGroupAnAncestor(this.formData.id, g.id, groupMap)),
      );
    },
    fetchPolicy: 'no-cache',
  }) public productGroups!: GQL_currentUnitProductGroups_currentUnit_productGroups[];

  private rules: IRules = {
    name: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: this.t_attr('ProductGroup', 'name') }),
      },
    ],
  };

  @Emit()
  private mutationDone() {}
}
